import { createRouter, createWebHistory } from 'vue-router'

import store from './store'
const scrollBehavior = (to, from, savedPosition) => {
    if (to.hash) {
        const element = document.querySelector(to.hash);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    } else if (savedPosition) {
        window.scrollTo({ top: savedPosition.y, behavior: 'smooth' });
    }
    return new Promise(resolve => {
        setTimeout(() => {
            if (to.hash) {
                resolve({ el: to.hash, behavior: 'smooth' });
            } else {
                resolve(savedPosition ? { x: 0, y: savedPosition.y } : { x: 0, y: 0 });
            }
        }, 500); // Adjust timing as necessary for page load or transitions
    });
}
const router = createRouter({
    "history": createWebHistory(),
    base: process.env.BASE_URL,
    scrollBehavior,
    // This is for the scroll top when click on any router link
    routes: [
        {
            publicPath: '',
            historyApiFallback: true,
            path: '',
            component: () => import('./layouts/full-layout/Layout'),
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    name: '403',
                    path: '/403',
                    component: () => import('./views/errors/403'),
                },
                {
                    name: 'Home',
                    path: '',
                    component: () => import('./views/Home'),
                },
                {
                    name: 'Dashboard',
                    path: 'dashboard',
                    component: () => import('./views/Dashboard'),
                },
                {
                    name: 'Companies',
                    path: 'companies',
                    meta: { model: 'company', action: 'read' },
                    component: () => import('./views/companies/List'),
                },
                {
                    name: 'Companies edit',
                    path: 'companies/:id',
                    meta: { model: 'company' },
                    component: () => import('./views/companies/Edit'),
                },
                {
                    name: 'Contacts',
                    path: 'contacts',
                    meta: { model: 'contact', action: 'read' },
                    component: () => import('./views/contacts/List'),
                },
                {
                    name: 'Contacts edit',
                    path: 'contacts/:id',
                    meta: { model: 'contact' },
                    component: () => import('./views/contacts/Edit'),
                },
                {
                    name: 'Employees',
                    path: 'employees',
                    meta: { model: 'employee', action: 'read' },
                    component: () => import('./views/employees/List'),
                },
                {
                    name: 'Employees edit',
                    path: 'employees/:id',
                    meta: { model: 'employee' },
                    component: () => import('./views/employees/Edit'),
                },
                {
                    name: 'Fields',
                    path: 'fields',
                    meta: { model: 'field', action: 'read' },
                    component: () => import('./views/fields/List'),
                },
                {
                    name: 'Floors',
                    path: 'floors',
                    meta: { model: 'floor', action: 'read' },
                    component: () => import('./views/floors/List'),
                },
                {
                    name: 'Floors edit',
                    path: 'floors/:id',
                    meta: { model: 'floor' },
                    component: () => import('./views/floors/Edit'),
                },
                {
                    name: 'Locations',
                    path: 'locations',
                    meta: { model: 'location', action: 'read' },
                    component: () => import('./views/locations/List'),
                },
                {
                    name: 'Locations edit',
                    path: 'locations/:id',
                    meta: { model: 'location' },
                    component: () => import('./views/locations/Edit'),
                },
                {
                    name: 'Notes',
                    path: 'notes',
                    meta: { model: 'note', action: 'read' },
                    component: () => import('./views/notes/List'),
                },
                {
                    name: 'Notifications',
                    path: 'notifications',
                    meta: { name: 'notification', action: 'read' },
                    component: () => import('./views/notifications/Index'),
                },
                {
                    name: 'Projects',
                    path: 'projects',
                    meta: { model: 'project', action: 'read' },
                    component: () => import('./views/projects/List'),
                },
                {
                    name: 'Projects edit',
                    path: 'projects/:id',
                    meta: { model: 'project' },
                    component: () => import('./views/projects/Edit'),
                },
                {
                    name: 'Plans',
                    path: 'plans',
                    meta: { model: 'plan', action: 'read' },
                    component: () => import('./views/plans/List'),
                },
                {
                    name: 'Plans edit',
                    path: 'plans/:id',
                    meta: { model: 'plan' },
                    component: () => import('./views/plans/Edit'),
                },
                {
                    name: 'Profile',
                    path: 'profile',
                    component: () => import('./views/Profile'),
                },
                {
                    name: 'Roles',
                    path: 'roles',
                    meta: { model: 'role', action: 'read' },
                    component: () => import('./views/roles/List'),
                },
                {
                    name: 'Roles Edit',
                    path: 'roles/:id',
                    meta: { model: 'role' },
                    component: () => import('./views/roles/Edit'),
                },
                {
                    name: 'Scripts',
                    path: 'scripts',
                    meta: { model: 'script', action: 'read' },
                    component: () => import('./views/scripts/List'),
                },
                {
                    name: 'Scripts edit',
                    path: 'scripts/:id',
                    meta: { model: 'script' },
                    component: () => import('./views/scripts/Edit'),
                },
                {
                    name: 'Reports',
                    path: 'reports',
                    meta: { model: 'report', action: 'read' },
                    component: () => import('./views/reports/List'),
                },
                {
                    name: 'Reports edit',
                    path: 'reports/:id',
                    meta: { model: 'report' },
                    component: () => import('./views/reports/Edit'),
                },
                {
                    name: 'Reports fill',
                    path: 'fill-report/:id',
                    meta: { model: 'report' },
                    component: () => import('./views/reports/Fill'),
                },
                {
                    name: 'Script templates',
                    path: 'scripttemplates',
                    meta: { model: 'scripttemplate', action: 'read' },
                    component: () => import('./views/scripttemplates/List'),
                },
                {
                    name: 'Scripts templates edit',
                    path: 'scripttemplates/:id',
                    meta: { model: 'scripttemplate' },
                    component: () => import('./views/scripttemplates/Edit'),
                },
                {
                    name: 'STABU',
                    path: 'stabu',
                    meta: { model: 'stabu', action: 'read' },
                    component: () => import('./views/stabu/List'),
                },
                {
                    name: 'Settings Edit',
                    path: 'settings',
                    meta: { model: 'setting' },
                    component: () => import('./views/settings/Edit'),
                },
                {
                    name: 'Tags',
                    path: 'tags',
                    meta: { model: 'tag', action: 'read' },
                    component: () => import('./views/tags/List'),
                },
                {
                    name: 'Tickets',
                    path: 'tickets',
                    meta: { model: 'ticket', action: 'read' },
                    component: () => import('./views/tickets/List'),
                },
                {
                    name: 'Translations',
                    path: 'translations',
                    meta: { model: 'translation', action: 'read' },
                    component: () => import('./views/translations/List'),
                },
                {
                    name: 'Workflows',
                    path: 'workflows',
                    meta: { model: 'workflow', action: 'read' },
                    component: () => import('./views/workflows/List'),
                },
                {
                    name: 'Workflows Edit',
                    path: 'workflows/:id',
                    meta: { model: 'workflow' },
                    component: () => import('./views/workflows/Edit'),
                },
            ]
        },
        {
            name: 'Login',
            path: '/login',
            component: () => import('./views/authentication/Login'),
        },
        {
            name: 'Error',
            path: '/error404',
            component: () => import('./views/Error'),
        },

        {
            path: '/authentication',
            component: () => import('./layouts/blank-layout/Blanklayout'),
        },
        {
            name: 'Portal',
            path: '/portal',
            publicPath: '/portal',
            component: () => import('./views/public/portal/Portal'),
        },
        {
            name: 'Complete registration',
            path: '/completeregistration',
            publicPath: '/completeregistration',
            component: () => import('./views/authentication/CompleteRegistration'),
        },
        {
            name: 'Password reset',
            path: '/resetpassword',
            publicPath: '/resetpassword',
            component: () => import('./views/authentication/PasswordReset'),
        },
        {
            publicPath: '',
            historyApiFallback: true,
            path: '',
            component: () => import('./layouts/full-layout/Layout'),
            children: [
                {
                    name: '403',
                    path: '/403',
                    component: () => import('./views/errors/403'),
                },
            ]
        },
    ],
})
router.beforeEach((to, from, next) => {
    store.state.loader = false;
    if(to.path === '/completeregistration' || to.path === '/resetpassword' || to.path === '/') {
        localStorage.removeItem("path");
    }
    else if(to.path !== '/login') {
        let path = to.path;
        if (to.query.id) {
            path += "?id=" + to.query.id;
        }
        localStorage.setItem("path", path);
    }
    if (to.matched.some(record => record.meta && record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next();
        } else {
            next('/login');
        }

    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.params.asset_id) {
        to.params.asset_id = parseInt(to.params.asset_id, 10) || null;
    }
    next();
})

export default router